module.exports = "https://tutorchat.chegg.com/static/media/avatar-admin.f8c3129d.svg";